var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Êtes-vous sûr de vouloir supprimer les produits suivants :")]),_vm._v(" "),_c('ul',_vm._l((_vm.$store.state.datatable.products.selected),function(project){return _c('li',[_vm._v("\n            "+_vm._s(project.label)+"\n        ")])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-120778b6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/list/Delete.vue
// module id = null
// module chunks = 